import { BehaviorSubject } from "rxjs";
import { filter } from "rxjs/operators";
import {
    ADD_TO_CART,
    CLICK_ACTIONS,
    ORDER_PURCHASE,
    PACIFICTO_CATEGORY,
    PARTNER_TYPE,
    PRODUCT_CHECKOUT,
    VIRTUAL_EVENT,
} from "../../constants/datalayer";

import { DataLayerProductList } from "./data-layer-model";
import { ENV } from "../../constants/env";
import SHA256 from "../helpers/crypto";

const dataLayerObject = {};
export default class Datalayer {
    static partner = null;

    static partnerType = null;

    static isSettedTransactionId = false;

    static _initialized = new BehaviorSubject(false);

    static initialized = Datalayer._initialized.pipe(
        filter(_initialized => _initialized)
    );

    static init = () => {
        if (Datalayer._initialized.value) {
            return;
        }
        Datalayer._initialized.next(true);
        this.loadScript();
        dataLayerObject.product = { ...{}, ...new DataLayerProductList() };
    };

    static loadScript = () => {
        // eslint-disable-next-line func-names
        (function(w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                "gtm.start": new Date().getTime(),
                event: "gtm.js",
            });
            const f = d.getElementsByTagName(s)[0];
            const j = d.createElement(s);
            const dl = l !== "dataLayer" ? `&l=${l}` : "";
            j.async = true;
            j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", ENV.GTM_CODE);
    };

    static pageView(
        url = "",
        pageName = "",
        partner = "",
        partnerType = "",
        documentId = ""
    ) {
        const isLandingUrl = url.includes("/inicio");
        const isThanksUrl = url.includes("/gracias");
        if (!Datalayer.isSettedTransactionId && !isLandingUrl) {
            return;
        }
        const event = {
            event: "virtualPage",
            pagePath: `${url}${document.location.search}`,
            pageName,
            partner,
            partnerType,
            ...(isLandingUrl && {
                clasePagina: "Hogar:HogarLeads:Inicio",
            }),
            ...(isThanksUrl && {
                clasePagina: "Hogar:HogarLeads:Gracias",
                userid: SHA256(documentId),
            }),
        };
        window.dataLayer.push(event);
        // eslint-disable-next-line consistent-return
        return event;
    }

    static setTransactionId(transactionId) {
        const event = {
            transactionId,
        };
        Datalayer.isSettedTransactionId = true;
        window.dataLayer.push(event);
    }

    static setPartner(partner, partnerType) {
        if (partner === PARTNER_TYPE.bcp.toLowerCase()) {
            partner = PARTNER_TYPE.bcp;
            partnerType = PARTNER_TYPE.bcp;
        } else if (partner.toLowerCase() === PARTNER_TYPE.mibanco.toLowerCase()) {
            partner = PARTNER_TYPE.mibanco;
            partnerType = PARTNER_TYPE.mibanco;
        } else if (partner.toLowerCase() === PARTNER_TYPE.crosssoat.toLowerCase()) {
            partner = PARTNER_TYPE.default;
            partnerType = PARTNER_TYPE.default;
        } else if (
            partnerType === PARTNER_TYPE.company ||
            partnerType === PARTNER_TYPE.client
        ) {
            partner = partner.toUpperCase();
        }
        const event = {
            partner,
            partnerType,
        };
        Datalayer.partner = partner;
        Datalayer.partnerType = partnerType;
        window.dataLayer.push(event);
    }

    static sendModal(type, name, label = "") {
        const event = {
            event: VIRTUAL_EVENT,
            category: PACIFICTO_CATEGORY,
            action: `Modal - ${type} - ${name}`,
            label: label || CLICK_ACTIONS.OPEN_MODAL,
        };

        window.dataLayer.push(event);
    }

    static sendClickAction(action, label, extra = {}) {
        const event = {
            event: VIRTUAL_EVENT,
            category: PACIFICTO_CATEGORY,
            action,
            label,
            ...extra,
        };

        window.dataLayer.push(event);
    }

    static addToCart(requestId, data) {
        const event = {
            event: ADD_TO_CART,
            dimension12: requestId,
            ecommerce: data,
        };
        window.dataLayer.push(event);
    }

    static productCheckout(requestId, data) {
        const event = {
            event: PRODUCT_CHECKOUT,
            dimension12: requestId,
            ecommerce: data,
        };
        window.dataLayer.push(event);
    }

    static orderPurchase(requestId, paymentMethod, period, data) {
        const event = {
            event: ORDER_PURCHASE,
            dimension12: requestId,
            dimension20: paymentMethod,
            dimension16: period,
            ecommerce: data,
        };
        window.dataLayer.push(event);
    }
}
